module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "shopping-cart-img"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("message.login")) + "\n            "), _c('router-link', {
    staticClass: "f-right",
    attrs: {
      "to": "/customer/account/register"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("message.register")) + "\n            ")])], 1), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    Your account registration is successful, we sent an email to your email, \n                    you need to login to your email and click the activation link to activate your account. \n                    If you have not received the email, you can resend the email by \n                    "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        return _vm.resendRegisterEnableEmail()
      }
    }
  }, [_vm._v("clicking here")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block customer-login"
  }, [_c('div', {
    staticClass: "account-form",
    attrs: {
      "id": "login-form"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "name": "editForm[email]",
      "value": "",
      "id": "email",
      "type": "email",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-text required-entry validate-password",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "editForm[password]",
      "id": "pass",
      "title": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), (_vm.loginCaptchaActive) ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    staticClass: "login-captcha-input",
    attrs: {
      "placeholder": "captcha",
      "type": "text",
      "name": "editForm[captcha]",
      "value": "",
      "size": "10"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "login-captcha-img",
    attrs: {
      "title": "click refresh",
      "src": _vm.captchaFile,
      "align": "absbottom"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-refresh",
    on: {
      "click": function($event) {
        return _vm.reflushCaptcha()
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-set"
  }, [_c('p', [_c('a', {
    staticClass: "button button-fill",
    attrs: {
      "href": "javascript:void(0)",
      "id": "js_registBtn"
    },
    on: {
      "click": function($event) {
        return _vm.loginAccount()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("message.sign_in")) + "\n                        ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "f-left",
    attrs: {
      "to": "/customer/account/forgotpassword"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.forgot_password")) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "third_login"
  }, [_c('div', {
    staticClass: "fago_login"
  }, [_c('img', {
    attrs: {
      "src": "//img.fancyecommerce.com/images/facebook.jpg"
    },
    on: {
      "click": function($event) {
        return _vm.facebookLogin()
      }
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//img.fancyecommerce.com/images/google.jpg"
    },
    on: {
      "click": function($event) {
        return _vm.googleLogin()
      }
    }
  }), _c('br')]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-email"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col2-set"
  }, [_c('div', {
    staticClass: "col-1 new-users"
  }, [_c('div', {
    staticClass: "buttons-set"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-2 registered-users"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28b402e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/account/Login.vue
// module id = 237
// module chunks = 1